{
  "labels": {
    "paste": "পেস্ট করুন",
    "pasteAsPlaintext": "প্লেইনটেক্সট হিসাবে পেস্ট করুন",
    "pasteCharts": "চার্ট পেস্ট করুন",
    "selectAll": "সবটা সিলেক্ট করুন",
    "multiSelect": "একাধিক সিলেক্ট করুন",
    "moveCanvas": "ক্যানভাস সরান",
    "cut": "কাট করুন",
    "copy": "কপি করুন",
    "copyAsPng": "পীএনজী ছবির মতন কপি করুন",
    "copyAsSvg": "এসভীজী ছবির মতন কপি করুন",
    "copyText": "লিখিত তথ্যের মতন কপি করুন",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "অধিকতর সামনে আনুন",
    "sendToBack": "অধিকতর পিছনে নিয়ে যান",
    "bringToFront": "সবার সামনে আনুন",
    "sendBackward": "সবার পিছনে নিয়ে যান",
    "delete": "মুছা",
    "copyStyles": "ডিজাইন কপি করুন",
    "pasteStyles": "ডিজাইন পেস্ট করুন",
    "stroke": "রেখাংশ",
    "background": "পটভূমি",
    "fill": "রং",
    "strokeWidth": "রেখাংশের বেধ",
    "strokeStyle": "রেখাংশের ডিজাইন",
    "strokeStyle_solid": "পুরু",
    "strokeStyle_dashed": "পাতলা",
    "strokeStyle_dotted": "বিন্দুবিন্দু",
    "sloppiness": "ভ্রান্তি",
    "opacity": "দৃশ্যমানতা",
    "textAlign": "লেখ অনুভূমি",
    "edges": "কোণ",
    "sharp": "তীক্ষ্ণ",
    "round": "গোল",
    "arrowheads": "তীরের শীর্ষভাগ",
    "arrowhead_none": "কিছু না",
    "arrowhead_arrow": "তীর",
    "arrowhead_bar": "রেখাংশ",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "ত্রিভূজ",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "লেখনীর মাত্রা",
    "fontFamily": "লেখনীর হরফ",
    "addWatermark": "এক্সক্যালিড্র দ্বারা প্রস্তুত",
    "handDrawn": "হাতে আঁকা",
    "normal": "স্বাভাবিক",
    "code": "কোড",
    "small": "ছোট",
    "medium": "মাঝারি",
    "large": "বড়",
    "veryLarge": "অনেক বড়",
    "solid": "দৃঢ়",
    "hachure": "ভ্রুলেখা",
    "zigzag": "আঁকাবাঁকা",
    "crossHatch": "ক্রস হ্যাচ",
    "thin": "পাতলা",
    "bold": "পুরু",
    "left": "বাম",
    "center": "কেন্দ্র",
    "right": "ডান",
    "extraBold": "অতি পুরু",
    "architect": "স্থপতি",
    "artist": "শিল্পী",
    "cartoonist": "চিত্রকার",
    "fileTitle": "ফাইলের নাম",
    "colorPicker": "রং পছন্দ করুন",
    "canvasColors": "ক্যানভাসের রং",
    "canvasBackground": "ক্যানভাসের পটভূমি",
    "drawingCanvas": "ব্যবহৃত ক্যানভাস",
    "layers": "মাত্রা",
    "actions": "ক্রিয়া",
    "language": "ভাষা",
    "liveCollaboration": "সরাসরি পারস্পরিক সহযোগিতা...",
    "duplicateSelection": "সদৃশ সিলেক্ট",
    "untitled": "অনামী",
    "name": "নাম",
    "yourName": "আপনার নাম",
    "madeWithExcalidraw": "এক্সক্যালিড্র দ্বারা তৈরি",
    "group": "দল গঠন করুন",
    "ungroup": "দল বিভেদ করুন",
    "collaborators": "সহযোগী",
    "showGrid": "গ্রিড দেখান",
    "addToLibrary": "সংগ্রহে যোগ করুন",
    "removeFromLibrary": "সংগ্রহ থেকে বের করুন",
    "libraryLoadingMessage": "সংগ্রহ তৈরি হচ্ছে",
    "libraries": "সংগ্রহ দেখুন",
    "loadingScene": "দৃশ্য তৈরি হচ্ছে",
    "align": "পংক্তিবিন্যাস",
    "alignTop": "উপর পংক্তি",
    "alignBottom": "নিম্ন পংক্তি",
    "alignLeft": "বাম পংক্তি",
    "alignRight": "ডান পংক্তি",
    "centerVertically": "উলম্ব কেন্দ্রিত",
    "centerHorizontally": "অনুভূমিক কেন্দ্রিত",
    "distributeHorizontally": "অনুভূমিকভাবে বিতরণ করুন",
    "distributeVertically": "উল্লম্বভাবে বিতরণ করুন",
    "flipHorizontal": "অনুভূমিক আবর্তন",
    "flipVertical": "উলম্ব আবর্তন",
    "viewMode": "দৃশ্য",
    "share": "ভাগ করুন",
    "showStroke": "",
    "showBackground": "",
    "toggleTheme": "",
    "personalLib": "",
    "excalidrawLib": "",
    "decreaseFontSize": "লেখনীর মাত্রা কমান",
    "increaseFontSize": "লেখনীর মাত্রা বাড়ান",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "লিঙ্ক সংশোধন",
      "editEmbed": "",
      "create": "লিঙ্ক তৈরী",
      "createEmbed": "",
      "label": "লিঙ্ক নামকরণ",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "",
      "exit": ""
    },
    "elementLock": {
      "lock": "আবদ্ধ করুন",
      "unlock": "বিচ্ছিন্ন করুন",
      "lockAll": "সব আবদ্ধ করুন",
      "unlockAll": "সব বিচ্ছিন্ন করুন"
    },
    "statusPublished": "প্রকাশিত",
    "sidebarLock": "লক",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "সংগ্রহে কিছু যোগ করা হয়নি",
    "hint_emptyLibrary": "এখানে যোগ করার জন্য ক্যানভাসে একটি বস্তু নির্বাচন করুন, অথবা নীচে, প্রকাশ্য সংগ্রহশালা থেকে একটি সংগ্রহ ইনস্টল করুন৷",
    "hint_emptyPrivateLibrary": "এখানে যোগ করার জন্য ক্যানভাসে একটি বস্তু নির্বাচন করুন"
  },
  "buttons": {
    "clearReset": "ক্যানভাস সাফ করুন",
    "exportJSON": "জেসন নিবদ্ধ করুন",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "ক্লিপবোর্ডে কপি করুন",
    "save": "জমা করুন",
    "saveAs": "অন্যভাবে জমা করুন",
    "load": "",
    "getShareableLink": "ভাগযোগ্য লিঙ্ক পান",
    "close": "বন্ধ করুন",
    "selectLanguage": "ভাষা চিহ্নিত করুন",
    "scrollBackToContent": "বিষয়বস্তুতে ফেরত যান",
    "zoomIn": "বড় করুন",
    "zoomOut": "ছোট করুন",
    "resetZoom": "স্বাভাবিক করুন",
    "menu": "তালিকা",
    "done": "সম্পন্ন",
    "edit": "সংশোধন করুন",
    "undo": "ফেরত যান",
    "redo": "পুনরায় করুন",
    "resetLibrary": "সংগ্রহ সাফ করুন",
    "createNewRoom": "নতুন রুম বানান",
    "fullScreen": "পূর্ণস্ক্রীন",
    "darkMode": "ডার্ক মোড",
    "lightMode": "লাইট মোড",
    "zenMode": "জেন মোড",
    "objectsSnapMode": "",
    "exitZenMode": "জেন মোড বন্ধ করুন",
    "cancel": "বাতিল",
    "clear": "সাফ",
    "remove": "বিয়োগ",
    "embed": "",
    "publishLibrary": "সংগ্রহ প্রকাশ করুন",
    "submit": "জমা করুন",
    "confirm": "নিশ্চিত করুন",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "এটি পুরো ক্যানভাস সাফ করবে। আপনি কি নিশ্চিত?",
    "couldNotCreateShareableLink": "ভাগ করা যায় এমন লিঙ্ক তৈরি করা যায়নি।",
    "couldNotCreateShareableLinkTooBig": "ভাগ করা যায় এমন লিঙ্ক তৈরি করা যায়নি: দৃশ্যটি খুব বড়",
    "couldNotLoadInvalidFile": "অবৈধ ফাইল লোড করা যায়নি",
    "importBackendFailed": "ব্যাকেন্ড থেকে আপলোড ব্যর্থ হয়েছে।",
    "cannotExportEmptyCanvas": "খালি ক্যানভাস নিবদ্ধ করা যাবে না।",
    "couldNotCopyToClipboard": "ক্লিপবোর্ডে কপি করা যায়নি।",
    "decryptFailed": "তথ্য ডিক্রিপ্ট করা যায়নি।",
    "uploadedSecurly": "আপলোডটি এন্ড-টু-এন্ড এনক্রিপশনের মাধ্যমে সুরক্ষিত করা হয়েছে, যার অর্থ হল এক্সক্যালিড্র সার্ভার এবং তৃতীয় পক্ষের দ্বারা পড়তে পারা সম্ভব নয়।",
    "loadSceneOverridePrompt": "বাহ্যিক অঙ্কন লোড করা আপনার বিদ্যমান দৃশ্য প্রতিস্থাপন করবে। আপনি কি অবিরত করতে চান?",
    "collabStopOverridePrompt": "অধিবেশন বন্ধ করা আপনার পূর্ববর্তী, স্থানীয়ভাবে সঞ্চিত অঙ্কন ওভাররাইট করবে। আপনি কি নিশ্চিত?\n\n(যদি আপনি আপনার স্থানীয় অঙ্কন রাখতে চান, তাহলে শুধু ব্রাউজার ট্যাবটি বন্ধ করুন।)",
    "errorAddingToLibrary": "বস্তুটি সংগ্রহে যোগ করা যায়নি",
    "errorRemovingFromLibrary": "বস্তুটি সংগ্রহ থেকে বিয়োগ করা যায়নি",
    "confirmAddLibrary": "এটি আপনার সংগ্রহে {{numShapes}} আকার(গুলি) যোগ করবে। আপনি কি নিশ্চিত?",
    "imageDoesNotContainScene": "এই ছবিতে কোনো দৃশ্যের তথ্য আছে বলে মনে হয় না৷ আপনি কি নিবদ্ধ করার সময় দৃশ্য এমবেডিং করতে সক্ষম?",
    "cannotRestoreFromImage": "এই ফাইল থেকে দৃশ্য পুনরুদ্ধার করা যায়নি",
    "invalidSceneUrl": "সরবরাহ করা লিঙ্ক থেকে দৃশ্য লোড করা যায়নি৷ এটি হয় বিকৃত, অথবা বৈধ এক্সক্যালিড্র জেসন তথ্য নেই৷",
    "resetLibrary": "এটি আপনার সংগ্রহ পরিষ্কার করবে। আপনি কি নিশ্চিত?",
    "removeItemsFromsLibrary": "সংগ্রহ থেকে {{count}} বস্তু বিয়োগ করা হবে। আপনি কি নিশ্চিত?",
    "invalidEncryptionKey": "অবৈধ এনক্রীপশন কী।",
    "collabOfflineWarning": ""
  },
  "errors": {
    "unsupportedFileType": "অসমর্থিত ফাইল।",
    "imageInsertError": "ছবি সন্নিবেশ করা যায়নি। পরে আবার চেষ্টা করুন...",
    "fileTooBig": "ফাইলটি খুব বড়। সর্বাধিক অনুমোদিত আকার হল {{maxSize}}৷",
    "svgImageInsertError": "এসভীজী ছবি সন্নিবেশ করা যায়নি। এসভীজী মার্কআপটি অবৈধ মনে হচ্ছে৷",
    "failedToFetchImage": "",
    "invalidSVGString": "এসভীজী মার্কআপটি অবৈধ মনে হচ্ছে৷",
    "cannotResolveCollabServer": "কোল্যাব সার্ভারের সাথে সংযোগ করা যায়নি। পৃষ্ঠাটি পুনরায় লোড করে আবার চেষ্টা করুন।",
    "importLibraryError": "সংগ্রহ লোড করা যায়নি",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "বাছাই",
    "image": "চিত্র সন্নিবেশ",
    "rectangle": "আয়তক্ষেত্র",
    "diamond": "রুহিতন",
    "ellipse": "উপবৃত্ত",
    "arrow": "তীর",
    "line": "রেখা",
    "freedraw": "কলম",
    "text": "লেখা",
    "library": "সংগ্রহ",
    "lock": "আঁকার পরে নির্বাচিত টুল সক্রিয় রাখুন",
    "penMode": "",
    "link": "একটি নির্বাচিত আকৃতির জন্য লিঙ্ক যোগ বা আপডেট করুন",
    "eraser": "ঝাড়ন",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "ক্যানভাস কার্যকলাপ",
    "selectedShapeActions": "বাছাই করা আকার(গুলি)র কার্যকলাপ",
    "shapes": "আকার(গুলি)"
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "একাধিক বিন্দু শুরু করতে ক্লিক করুন, একক লাইনের জন্য টেনে আনুন",
    "freeDraw": "ক্লিক করুন এবং টেনে আনুন, আপনার কাজ শেষ হলে ছেড়ে দিন",
    "text": "বিশেষ্য: আপনি নির্বাচন টুলের সাথে যে কোনো জায়গায় ডাবল-ক্লিক করে পাঠ্য যোগ করতে পারেন",
    "embeddable": "",
    "text_selected": "লেখা সম্পাদনা করতে ডাবল-ক্লিক করুন বা এন্টার টিপুন",
    "text_editing": "লেখা সম্পাদনা শেষ করতে এসকেপ বা কন্ট্রোল/কম্যান্ড যোগে এন্টার টিপুন",
    "linearElementMulti": "শেষ বিন্দুতে ক্লিক করুন অথবা শেষ করতে এসকেপ বা এন্টার টিপুন",
    "lockAngle": "ঘোরানোর সময় আপনি শিফ্ট ধরে রেখে কোণ সীমাবদ্ধ করতে পারেন",
    "resize": "আপনি আকার পরিবর্তন করার সময় শিফ্ট ধরে রেখে অনুপাতকে সীমাবদ্ধ করতে পারেন,\nকেন্দ্র থেকে আকার পরিবর্তন করতে অল্ট ধরে রাখুন",
    "resizeImage": "আপনি শিফ্ট ধরে রেখে অবাধে আকার পরিবর্তন করতে পারেন, কেন্দ্র থেকে আকার পরিবর্তন করতে অল্ট ধরুন",
    "rotate": "আপনি ঘোরানোর সময় শিফ্ট ধরে রেখে কোণগুলিকে সীমাবদ্ধ করতে পারেন",
    "lineEditor_info": "",
    "lineEditor_pointSelected": "বিন্দু(গুলি) মুছতে ডিলিট টিপুন, কন্ট্রোল/কম্যান্ড যোগে ডি টিপুন নকল করতে অথবা সরানোর জন্য টানুন",
    "lineEditor_nothingSelected": "সম্পাদনা করার জন্য একটি বিন্দু নির্বাচন করুন (একাধিক নির্বাচন করতে শিফ্ট ধরে রাখুন),\nঅথবা অল্ট ধরে রাখুন এবং নতুন বিন্দু যোগ করতে ক্লিক করুন",
    "placeImage": "ছবিটি স্থাপন করতে ক্লিক করুন, অথবা নিজে আকার সেট করতে ক্লিক করুন এবং টেনে আনুন",
    "publishLibrary": "আপনার নিজস্ব সংগ্রহ প্রকাশ করুন",
    "bindTextToElement": "লেখা যোগ করতে এন্টার টিপুন",
    "deepBoxSelect": "",
    "eraserRevert": "মুছে ফেলার জন্য চিহ্নিত উপাদানগুলিকে ফিরিয়ে আনতে অল্ট ধরে রাখুন",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "প্রিভিউ দেখাতে অপারগ",
    "canvasTooBig": "ক্যানভাস অনেক বড়।",
    "canvasTooBigTip": "বিশেষ্য: দূরতম উপাদানগুলোকে একটু কাছাকাছি নিয়ে যাওয়ার চেষ্টা করুন।"
  },
  "errorSplash": {
    "headingMain": "একটি ত্রুটির সম্মুখীন হয়েছে৷ চেষ্টা করুন <button>পৃষ্ঠাটি পুনরায় লোড করার।</button>",
    "clearCanvasMessage": "যদি পুনরায় লোড করা কাজ না করে, চেষ্টা করুন <button>ক্যানভাস পরিষ্কার করার।</button>",
    "clearCanvasCaveat": " এর ফলে কাজের ক্ষতি হবে ",
    "trackedToSentry": "ত্রুটি {{eventId}} আমাদের সিস্টেমে ট্র্যাক করা হয়েছিল।",
    "openIssueMessage": "আমরা ত্রুটিতে আপনার দৃশ্যের তথ্য অন্তর্ভুক্ত না করার জন্য খুব সতর্ক ছিলাম। আপনার দৃশ্য ব্যক্তিগত না হলে, আমাদের অনুসরণ করার কথা বিবেচনা করুন <button>ত্রুটি ইতিবৃত্ত।</button> অনুগ্রহ করে GitHub ইস্যুতে অনুলিপি এবং পেস্ট করে নীচের তথ্য অন্তর্ভুক্ত করুন।",
    "sceneContent": "দৃশ্য বিষয়বস্তু:"
  },
  "roomDialog": {
    "desc_intro": "আপনি আপনার সাথে সহযোগিতা করার জন্য আপনার বর্তমান দৃশ্যে লোকেদের আমন্ত্রণ জানাতে পারেন৷",
    "desc_privacy": "চিন্তা করবেন না, সেশনটি এন্ড-টু-এন্ড এনক্রিপশন ব্যবহার করে, তাই আপনি যা আঁকবেন তা গোপন থাকবে। এমনকি আমাদের সার্ভার আপনি যা নিয়ে এসেছেন তা দেখতে সক্ষম হবে না।",
    "button_startSession": "সেশন শুরু করুন",
    "button_stopSession": "সেশন বন্ধ করুন",
    "desc_inProgressIntro": "লাইভ-সহযোগীতার সেশন এখন চলছে।",
    "desc_shareLink": "আপনি যার সাথে সহযোগিতা করতে চান তাদের সাথে এই লিঙ্কটি ভাগ করুন: ",
    "desc_exitSession": "অধিবেশন বন্ধ করা আপনাকে রুম থেকে সংযোগ বিচ্ছিন্ন করবে, কিন্তু আপনি স্থানীয়ভাবে দৃশ্যের সাথে কাজ চালিয়ে যেতে সক্ষম হবেন। মনে রাখবেন যে এটি অন্য লোকেদের প্রভাবিত করবে না এবং তারা এখনও তাদের সংস্করণে সহযোগিতা করতে সক্ষম হবে।",
    "shareTitle": "এক্সক্যালিড্র লাইভ সহযোগিতা সেশনে যোগ দিন"
  },
  "errorDialog": {
    "title": "ত্রুটি"
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "নিবদ্ধ",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "",
    "click": "ক্লিক",
    "deepSelect": "",
    "deepBoxSelect": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "",
    "drag": "",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "অথবা",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "",
    "githubUsername": "",
    "twitterUsername": "",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "কোণ",
    "element": "",
    "elements": "",
    "height": "",
    "scene": "",
    "selected": "",
    "storage": "",
    "title": "",
    "total": "",
    "version": "",
    "versionCopy": "",
    "versionNotAvailable": "",
    "width": "প্রস্থ"
  },
  "toast": {
    "addedToLibrary": "সংগ্রহশালায় যুক্ত হয়েছে",
    "copyStyles": "",
    "copyToClipboard": "ক্লিপবোর্ডে কপি করা হয়েছে।",
    "copyToClipboardAsPng": "",
    "fileSaved": "",
    "fileSavedToFilename": "",
    "canvas": "",
    "selection": "বাছাই",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
